"use client"

import { trackExperiments } from "@/platform/experiments/experiments.client"
import type { TreatmentConfig } from "@/platform/experiments/types"
import { useVisibleExposure } from "@/platform/experiments/use-visible-exposure"

interface ClientExperimentTrackerProps {
  experiment: TreatmentConfig<unknown>
}

export const ClientExperimentTracker = ({ experiment }: ClientExperimentTrackerProps) => {
  useVisibleExposure(`${experiment.featureName}:${experiment.trackingKey}:${experiment.treatmentName}`, () => trackExperiments(experiment))

  return null
}
